export default __webpack_public_path__ + "static/BT_Benefits_Carousel_08-a2f405b4abd845baec531758d9f88287.jpg";